import React, { useEffect, useState } from "react";
import { Download, FileUp, Info } from "lucide-react";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import api from "../../api/axios";

const DutyRoasterUpload = () => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const generateCurrentWeek = () => {
    const dates = {};
    const today = new Date();

    // Calculate Monday of the current week
    const monday = new Date(today);
    const day = today.getDay(); // Sun=0, Mon=1, Tue=2...
    const diff = (day === 0 ? -6 : 1) - day; // Handle Sunday correctly
    monday.setDate(today.getDate() + diff);

    // Loop through 7 days
    for (let i = 0; i < 7; i++) {
      const d = new Date(monday);
      d.setDate(monday.getDate() + i);
      const formatted = d.toISOString().split("T")[0];
      dates[formatted] = "G";
    }

    return dates;
  };

  const downloadSampleDutyRosterExcel = () => {
    const sampleData = [
      {
        employee_code: "00001",
        ...generateCurrentWeek(),
      },
    ];
    const ws = XLSX.utils.json_to_sheet(sampleData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sample");

    XLSX.writeFile(wb, "sample_duty_roster.xlsx");
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async (e) => {
    e.preventDefault();

    if (!file) {
      Swal.fire("Error", "Please select a file before uploading", "error");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    setLoading(true);
    try {
      const res = await api.post("/hrms/rosters/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      const response = res.data.data;

      if (response.errors && response.errors.length > 0) {
        let html = "";

        response.errors.forEach((err) => {
          html += `
                <div style="text-align:left; margin-bottom:8px;">
                  <strong>Row ${err.row}</strong> (${err.employee_code})<br/>
                  ${Object.keys(err.errors)
                    .map((k) => `• ${err.errors[k][0]}`)
                    .join("<br/>")}
                </div>
              `;
        });

        Swal.fire({
          icon: "error",
          title: "Upload Failed",
          html: html,
          width: 500,
        });

        return;
      }

      Swal.fire(
        "Success",
        "File uploaded and processed successfully!",
        "success"
      );

      setFile(null);
    } catch (error) {
      console.error("Upload failed:", error);
      Swal.fire("Error", "Failed to upload file. Please try again.", "error");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="duty-roster-upload">
      <div className="duty-roster-upload-cont">
        <div class="d-flex flex-column">
          <h5 class="fs-4 fw-semibold m-0">Upload & Validate Duty Roster</h5>
          <span class="text-muted fs-6">
            Select an Excel file to check for errors before processing.
          </span>
        </div>
        <div className="duty-roster-upload-inner-cont mt-3">
          <Info size={20} />
          <div class="d-flex flex-column">
            <h6 class="fs-5 fw-semibold m-0">File Format Instructions</h6>
            <span class="text-dark fs-6">
              Ensure your Excel file has a column named 'Emp. Code' for
              validation. Column headers for dates must be in 'YYYY-MM-DD'
              format. You can download a sample file to see the required format.
            </span>
          </div>
        </div>
        <div className="row row-gap-3 mt-4">
          <form onSubmit={handleUpload} className="row align-items-center g-3">
            <div className="col-lg-8 col-sm-12 col-12">
              <input
                type="file"
                accept=".xlsx, .xls"
                className="form-control"
                onChange={handleFileChange}
                disabled={loading}
              />
            </div>
            <div className="col-lg-2 col-sm-12 col-12">
              <button
                type="submit"
                disabled={loading || !file}
                className="btn duty-roster-upload-btn gap-1 w-100"
              >
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Uploading...
                  </>
                ) : (
                  <>
                    <FileUp size={16} />
                    Upload & Process
                  </>
                )}
              </button>
            </div>
            <div className="col-lg-2 col-sm-12 col-12">
              <button
                type="button"
                className="btn duty-roster-sample-btn gap-2 w-100"
                onClick={downloadSampleDutyRosterExcel}
              >
                <Download size={16} />
                Sample
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default DutyRoasterUpload;
